import Axios from "./index";

export const commentable_types = {
  Post: "posts",
  Playlist: "playlists"
};

export const commentables = ["Post", "Playlist"];

export const addComment = (type, id, params) => {
  return Axios.post(`/user/${commentable_types[type]}/${id}/comments`, params);
};
